import videojs from 'video.js';

class ButtonGroupComponent extends videojs.getComponent('Component') {
  constructor(player, options) {
    super(player, options);
    this.addClass('vjs-button-group__component');
  }
}

videojs.registerComponent('ButtonGroupComponent', ButtonGroupComponent);

